export default {
    param:{
        name:"名称",
        param_content_name_placeholder:'请输入参数内容名称',
        code:"编码",
        desc:"描述",
        type:"类型",
        content:"内容",
        param_content_name:"参数内容名称",
        param_content_code:"参数内容编码",
        param_contetn_value:"参数内容值",
        place_holder:"请输入",

        // 返回状态码对应的提示信息
        code_1:"删除成功",
        code_3:"系统错误",
        code_0:"删除失败",
        code_400:"失败",
        code_200:"成功",
        code_407:"名称已存在",
        code_408:"编码已存在",
        code_409:"编码已存在",
        code_other:"系统错误",

        title_add_param_content:"新增参数内容",
        title_add_param_type:"新增参数类型"
    }
}